import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inner: [
                {
                    id: 1,
                    icon: 'fa fa-check-square',
                    text: 'Wide range of premium plywood, MDF boards, and blockboards'
                },
                {
                    id: 2,
                    icon: 'fa fa-check-square',
                    text: 'Quality doors - flash doors, mahogany doors, and custom designs'
                },
                {
                    id: 3,
                    icon: 'fa fa-check-square',
                    text: 'Complete hardware supplies - screws, hinges, handles, and tools'
                },
                {
                    id: 4,
                    icon: 'fa fa-check-square',
                    text: 'Premium paints, cement, and construction finishing materials'
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row-about">
                <div className="container-fluid">
                    <div className="row equalize sm-equalize-auto">
                        <div className="col-md-6 half-background style-1"/>
                        <div className="col-md-6 bg-light-grey">
                            <div className="themesflat-spacer clearfix" data-desktop={64} data-mobile={60} data-smobile={60} />
                            <div className="themesflat-content-box clearfix" data-margin="0 25% 0 4.5%" data-mobilemargin="0 0 0 4.5%">
                                <div className="themesflat-headings style-1 clearfix">
                                    <h2 className="heading">WELCOME TO K.LIZZ CLASSIC HARDWARE</h2>
                                    <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />                                               
                                    <p className="sub-heading margin-top-30">Located in Nairobi, we are your trusted partner for quality building materials. K.Lizz Classic Hardware proudly offers:</p>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={26} data-mobile={35} data-smobile={35} />
                                <div className="content-list">
                                    <div className="themesflat-list has-icon style-1 icon-left clearfix">
                                        <div className="inner">
                                            {
                                                this.state.inner.map(data => (
                                                    <span className="item" key={data.id}>
                                                        <span className="icon"><i className={data.icon} /></span>
                                                        <span className="text">{data.text}</span>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={28} data-mobile={35} data-smobile={35} />
                                <div className="company-tagline" style={{marginBottom: '20px'}}>
                                    <p style={{fontSize: '18px', fontWeight: '600', color: '#c41e3a', fontStyle: 'italic'}}>
                                        "We Flow With Qualities"
                                    </p>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={14} data-mobile={15} data-smobile={15} />
                                <div className="elm-button">
                                    <Link to="/contact-01" className="themesflat-button bg-white">CONTACT US</Link>
                                </div>
                            </div>
                            <div className="themesflat-spacer clearfix" data-desktop={75} data-mobile={60} data-smobile={60} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;